<template>
	<div class="filelibrarydetail">
		<headerview :cur="4"></headerview>
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipconNav :title="'证书模板'" :name="[{label:'证书模板',url:'/downloadlist?signtype=6'},{label:'详情',url:''}]" :imgtype="'2'" width="1.73"></tipconNav>
				</div>

				<div class="min-h">
					<div class="textdetails">
						<myShare></myShare>

						<div class="title">{{ informdata.title }}</div>
						<div class="timesource">
							{{ informdata.datetime }}
							<span style="margin-left: 20px;" v-if='informdata.source'>来源:{{ informdata.source }}</span>
						</div>
						<div class="line"></div>

						<div class="msg" v-html="informdata.contentval"></div>
					</div>
				</div>
				<!-- 下载 -->
				<div class="imgconbox" @click="downloadFile(informdata)" v-if='informdata.fileId_dictText||informdata.uploadHref'>
					下载证书
					<div class="imgcon"></div>
				</div>
			</div>	
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
		informdata:{
			title:"标题名称标题名称标题名称",
			source:"来源来着",
			datetime:"2021-01-01 13:12:00",
			contentval:"文本内容文本内容文本内容文本内容文本内容"
		},
		id:"",
	  
    };
  },
  
  mounted() {
		this.$onScrollT()
		if(this.$route.query) {
			this.id = this.$route.query.id;
		}
		
		this.getDetail()
  },

  methods: {
	  	downloadFile(item) {
			if(item.uploadType==1){
				window.open(item.uploadHref)
			}else{ 
				window.open(this.$fileAccessHttpUrl(item.fileId_dictText))
			}
			
		},
	  	wxshare() {},
		// https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey
		// http://connect.qq.com/widget/shareqq/index.html?url={{url}}&title={{title}}&source={{source}}&desc={{desc}}&pics={{image}}&summary={{summary}}
		qqshare() {
			window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + encodeURIComponent(document.location.href));
			// window.open('http://connect.qq.com/widget/shareqq/index.html?url=' + escape(document.location.href));
		},
	    //文件库
	    getDetail(){
	    	this.$get(`/web/info/queryStudyDataById?id=${this.id}`).then(res=>{
	    		  if(res.success){
					  	this.informdata= res.result
	    				this.informdata.title = res.result.compilationTitle
	    				this.informdata.source = res.result.source
	    				this.informdata.datetime = res.result.createTime
	    				this.informdata.contentval = res.result.compilationContent		
						this.informdata.fileId_dictText=res.result.fileId_dictText
	    		  }
	    	})
	    },
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.filelibrarydetail{
	.imgconbox{
		display: flex;
		// color: #E61F26;
		color: #333333;
		cursor: pointer;
	}
	.imgcon {
		margin-bottom: 50px;
		margin-left: 10px;
		width: 27px;
		height: 17px;
		background: url(../../../static/img/downz.png) no-repeat top center/ 100% 100%;
	}
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
    		padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			
		}
			
	}
	.textdetails {
		.shareto {
			height: 50px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			.imgwx {
				cursor: pointer;
				margin-left: 20px;
				height:22px;
				width:26px;
			}
			.imgqq {
				cursor: pointer;
				margin-left: 20px;
				height:22px;
				width:18px;
			}
		}
		.title {
			font-size: 30px;
			font-weight: bold;
			color: #333333;
			text-align: center;
			margin-top: 40px;
			min-height:50px;
			line-height:50px;
		}
		.timesource {
			font-size: 16px;
			color: #666666;
			text-align: center;
			height: 30px;
			line-height:30px;
		}
		.line {
			width: 100%;
			height: 1px;
			background-color: #ededed;
		}

		.msg {
			padding: 40px;
		}

		.msg::-webkit-scrollbar {
			display: none;
		}
	}		
	
	
}

</style>

<style scoped>
/deep/ .msg img{
	max-width: 100%;
	vertical-align: middle
}
</style>
